import React from 'react'
import { getVisibleCategories, getReportCategoryKeys } from '../helpers'

import { factors } from './constants'

export const useIntroductionState = ({ project, language, response }) => {
  const outcomeFactors = factors.map(({ key, isHighGood, description }) => ({
    label: key,
    score: response[0].scores[key] * 100,
    description,
    isHighGood,
  }))

  const categoryKeys = getReportCategoryKeys(project?.profile)

  const visibleCategories =
    categoryKeys.length && response && response?.every(cat => cat?.scores)
      ? getVisibleCategories(
          categoryKeys,
          response?.map(response => response.scores),
          language,
        )
      : []

  return {
    state: {
      outcomeFactors,
      visibleCategories,
    },
  }
}
